import {PaidStatus} from "./enums/PaidStatus";

export class PaymentDetails{

    public readonly status: PaidStatus;
    public readonly merchantTransactionId?: string;

    constructor(status: PaidStatus, merchantTransactionId?: string) {
        this.status = status;
        this.merchantTransactionId = merchantTransactionId;
    }

}